import $ from "jquery";
import "./../styles/main.scss";
require('./woocommerce/Global');
require("./pages/availability");
// require("./helpers/ihavecookies");
import Siema from "siema";
import AOS from "aos";
import Glightbox from "glightbox";
$(document).ready(function () {
    var gl = Glightbox({});
    // const viewCookieBannerButton = document.querySelector(".view-cookie-banner");
    // if (viewCookieBannerButton !== void 0) {
    //     viewCookieBannerButton.addEventListener("click", (e) => {
    //         e.preventDefault();
    //         CookieConsentNode.showDetails();
    //     });
    // }
    if ($(window).width() < 600) {
        $("[data-aos='fade-left']").attr("data-aos", "fade-up");
    }
    AOS.init({
        disable: 'mobile'
    });
    setTimeout(function () { AOS.refresh(); }, 500);
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $("#menu-switcher").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
    $('.sliderWrapper').each(function (k, v) {
        var siema = $(v).find(".siema").get(0);
        var slider = new Siema({
            selector: siema,
            duration: 300,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: false,
            threshold: 20,
            loop: true,
            rtl: false
        });
        $(v).on("click", ".arrow", function (e) {
            e.preventDefault();
            if ($(e.currentTarget).data("direction") == "<")
                slider.prev();
            else if ($(e.currentTarget).data("direction") == ">")
                slider.next();
        });
        if ($(v).hasClass("gallery-concept")) {
            $(".page-template-tpl-concept").on("click", "#future .gallery li", function (e) {
                slider.goTo($(e.currentTarget).index() + 1);
            });
        }
    });
    if ($('#interiors .slides').length) {
        var siema = $('#interiors .slides').get(0);
        var controls_1 = $('#interiors .controls');
        var slider_1 = new Siema({
            selector: siema,
            duration: 300,
            easing: 'ease-out',
            perPage: 1,
            startIndex: 0,
            draggable: true,
            multipleDrag: false,
            threshold: 20,
            loop: true,
            rtl: false,
            onInit: function () {
            },
            onChange: function () {
                controls_1.find(".current").removeClass("current");
                controls_1.children("ul").children("li:eq(" + slider_1.currentSlide + ")").addClass("current");
            }
        });
        controls_1.on("click", "li", function (e) {
            slider_1.goTo($(e.currentTarget).index());
        });
    }
});
